<template>
  <div></div>
</template>

<script>
export default {
  name: "CamerasGallery"
}
</script>

<style scoped>

</style>
